import { IRobaTranslations } from '@/i18n/IRobaTranslations'

const translations: IRobaTranslations = {
  COMMON: {
    CANCEL: 'Annuleren',
    CLEAR_ALL_FILTERS: 'Wis alle filters',
    CLEAR_FILTERS: 'Wis filters',
    COMPANY: 'Bedrijf',
    DATE: 'Datum',
    DATE_CREATED: 'Aangemaakt op',
    DATE_FROM: 'Datum vanaf',
    DATE_PLACEHOLDER: 'Dag | Maand | Jaar',
    DATE_UNTIL: 'Datum tot',
    DOCUMENTS: 'Documenten',
    DOWNLOAD: 'Download',
    EMAIL: 'E-mail',
    FILTERS: 'Filters',
    HELP: 'Help',
    IMPERSONATE: 'Impersonate',
    NAME: 'Naam',
    NEXT: 'Volgende',
    NO: 'Nee',
    PREVIOUS: 'Vorige',
    NO_RESULTS: 'Sorry, we hebben geen {0} gevonden',
    PASSWORD: 'Wachtwoord',
    REMOVE: 'Verwijderen',
    SORT_BY: 'Sorteren op',
    STATUS_PORTAL_FILTER_TITLE: 'Status portal',
    USER: 'Gebruiker',
    VERSIONS: 'Versies',
    YES: 'Ja',
    PORTAL: 'Portaal',
    MY_ENVIRONMENT: 'Mijn omgeving'
  },
  MENU: {
    DASHBOARD: 'Dashboard',
    SHIPMENT_REQUEST: 'Verzendingsverzoek',
    DOCUMENTS: 'Documenten',
    USER_MANAGEMENT: 'Gebruikers documentenportaal',
    COMPANIES: 'Bedrijven'
  },
  MY_ENVIRONMENT: {
    YOUR_PROFILE: 'Uw profiel',
    USERS: 'Gebruikers',
    NOTIFICATIONS: 'Meldingen',
    SUPPORT: 'Support',
    LOG_OUT: 'Uitloggen',
    CHANGE_COMPANY: 'Wissel bedrijf',
    CHANGE_USER: 'Wissel gebruiker',
    PROFILE: {
      ROLE: 'Rol',
      CUSTOMER_NR: 'Klant nummer.',
      COMPANY: 'Bedrijf',
      FIRST_NAME: 'Voornaam',
      LAST_NAME: 'Achternaam',
      STATUS_PORTAL: 'Status',
      PERSONAL_INFORMATION: 'Persoonlijke informatie',
      YOUR_NOTIFICATIONS: 'Uw meldingen',
      DOCUMENT_NOTIFICATION: 'Documenten melding',
      GENERAL_NOTIFICATION: 'Algemene melding',
      GENERAL_NOTIFICATION_TEXT: 'Aan het einde van elke dag ontvangt u een algemene melding, zodat u op de hoogte blijft van nieuwe documenten die zijn toegevoegd aan het portaal.',
      RECEIVE_GENERAL_NOTIFICATION: 'Algemene melding ontvangen',
      NO_SUBSCRIPTIONS: 'Geen aangemelde meldingen'
    },
    USER: {
      ACTIVE_DESCRIPTION: 'Weet u zeker dat u de status van deze gebruiker wilt wijzigen in "Actief"? Let op, alle gebruikers die door deze beheerder zijn aangemaakt worden "Actief".',
      ACTIVE_TITLE: 'Status veranderen naar "Actief"?',
      ADMINISTRATOR: 'Klant (Administrator)',
      ADMINISTRATOR_DESCRIPTION: 'Een Administrator kan gebruikers en beheerders aanmaken en e-mailadressen toevoegen onder notificaties.',
      CHANGE_TO_ACTIVE: 'Zet op "Actief".',
      CHANGE_TO_INACTIVE: 'Zet op "Inactief".',
      CREATE_USER: 'Aanmaken gebruiker',
      CREATE_USER_DESCRIPTION: 'De gebruiker die u nu aanmaakt heeft de status "Inactief" totdat u het e-mailadres bevestigt en een wachtwoord aanmaakt.',
      DELETE: 'Verwijder gebruiker',
      DELETE_DESCRIPTION: 'Weet u zeker dat u deze gebruiker wil verwijderen? Let op, gebruikers die door deze beheerder zijn aangemaakt zullen verloren gaan .',
      DESCRIPTION: 'Een gebruiker heeft toegang tot het portaal na bevestiging. Indien de e-mail niet is bevestigd, blijft een gebruiker inactief.',
      EDIT_USER: 'Wijzig gebruiker',
      EDIT_USER_DESCRIPTION: 'De gebruiker die u nu wijzigt heeft de status "Inactief" totdat u het e-mailadres bevestigt en een wachtwoord aanmaakt.',
      EMAIL_LANGUAGE: 'Selecteer taal van te ontvangen emails',
      EMAIL_LANGUAGE_DISABLED_LABEL: 'Taal emails',
      FIRST_NAME: 'Voornaam',
      INACTIVE_DESCRIPTION: 'Weet u zeker dat u de status van deze gebruiker wilt wijzigen in "Inactief"? Let op, alle gebruikers die door deze beheerder zijn aangemaakt worden "Inactief".',
      INACTIVE_TITLE: 'Status veranderen naar "Inactief"?',
      LAST_NAME: 'Achternaam',
      MANAGER: 'Manager',
      MANAGER_DESCRIPTION: 'Een manager heeft naast dezelfde rechten als een gebruiker ook de bevoegdheid voor het aanmaken van gebruikers en toevoegen van e-mails onder meldingen.',
      NO_USERS_FOUND: 'Sorry, we hebben geen gebruikers gevonden',
      ROLE: 'Rol',
      ROW_LABEL: {
        NAME: 'Naam',
        LAST_LOGIN: 'Laastse login',
        LINKED_COMPANIES: 'Verbonden bedrijven'
      },
      SEARCH_TEXT: 'Zoek een gebruiker op voornaam, achternaam of e-mail.',
      SEARCH_TEXT_COMPANY: 'Zoek een gebruiker op voornaam, achternaam, bedrijfsnaam, e-mail of klantnummer',
      SET_STATUS_ACTIVE: 'Zet status op "Actief"',
      SET_STATUS_INACTIVE: 'Zet status op "Inactief".',
      STATUS_PORTAL: 'Status',
      SUPERADMIN: 'Super Admin',
      SUPERADMIN_DESCRIPTION: 'Dit is een superadministrator',
      SUPPORT: 'Roba support',
      SUPPORT_DESCRIPTION: 'Roba support kan zich voordoen als een gebruiker en helpen met vragen over het portaal',
      USER: 'Gebruiker',
      USER_DESCRIPTION: 'Een gebruiker heeft toegang tot het portaal en kan alle documenten inzien.'
    },
    NOTIFICATION: {
      ADDED_EMAIL_ADDRESSES: 'Toegevoegde e-mailadressen',
      ADD_EMAIL: 'E-mail toevoegen',
      ADD_EMAIL_DESCRIPTION: 'U krijgt een melding zodra er een nieuw type document wordt geüpload naar het portaal of u ontvangt per e-mail de bijgevoegde documenten.',
      ADD_EMAIL_TO_NOTIFICATION: 'Voeg een e-mailadres toe aan meldingen.',
      DELETE_EMAIL: 'E-mail verwijderen',
      DELETE_EMAIL_NOTE: 'E-mail wordt uit deze documenten verwijderd',
      EDIT_EMAIL: 'E-mail bewerken',
      EMAIL_DESCRIPTION: 'De toegevoegde e-mailadressen ontvangen {0} documenten per mail zodra deze door Roba Metals naar het portaal worden geüpload.',
      EMAIL_SEARCH: 'Typ hier het e-mailadres dat u zoekt.',
      INVOICES: 'Factuur',
      NOTIFICATION_TEXT: 'U krijgt een melding zodra er een nieuw type document wordt geüpload naar het portaal of u ontvangt per e-mail de bijgevoegde documenten.',
      NOTSET: 'Niet ingesteld',
      NO_EMAILS_ADDED: 'Geen e-mailadressen toegevoegd',
      OPTIONS: 'Opties voor meldingen',
      OPTIONS_TEXT:
        'De geselecteerde documenten worden verzonden naar het e-mailadres zodra deze worden geüpload naar het portaal. Aan het einde van elke dag ontvangt u een algemene melding, zodat de gebruiker weet dat er nieuwe documenten zijn toegevoegd aan het portaal.',
      OPTIONS_SELECT_DOCUMENTS: 'Selecteer documenten die u per e-mail wil verzenden.',
      PACKINGSLIPS: 'Verpakkingslip & Certificaten',
      SALESORDERS: 'Verkooporder',
      SALESAGREEMENTS: 'Verkoopovereenkomst',
      LANGUAGE: {
        NL: 'Nederlands',
        DE: 'Duits',
        FR: 'Frans',
        EN: 'Engels'
      }
    }
  },
  LOGIN: {
    LOGIN: 'Inloggen',
    FORGOT_PASSWORD: 'Wachtwoord vergeten',
    GENERAL_PURCHASING_CONDITIONS: 'Algemene Inkoopvoorwaarden',
    GENERAL_SALES_CONDITIONS: 'Algemene Verkoopvoorwaarden',
    DISCLAIMER: 'Disclaimer'
  },
  SUPPORT: {
    BACK_TO_LOGIN: 'Naar inloggen',
    TITLE: 'Support',
    TEXT: 'Indien u problemen ervaart met het portaal of vragen heeft over de inhoud, neem dan contact op met uw accountmanager via e-mail of telefoon.'
  },
  CREATE_PASSWORD: {
    CREATE: 'Maak account',
    CREATE_PASSWORD: 'Maak een wachtwoord',
    REPEAT_PASSWORD: 'Herhaal wachtwoord',
    VALIDATION: {
      LENGTH: 'Minimaal 7 tekens',
      ONE_LOWERCASE: 'Minimaal 1 kleine letter',
      ONE_SPECIAL_CHARACTER: 'Minimaal 1 speciale teken',
      EQUAL_PASSWORDS: 'Gelijke wachtwoorden'
    }
  },
  REQUEST_PASSWORD: {
    REQUEST: 'Vraag aan',
    REQUEST_PASSWORD: 'Nieuw wachtwoord aanvragen',
    REQUEST_PASSWORD_SENT: 'We hebben u een e-mail gestuurd',
    TEXT: 'Indien u problemen ervaart met het portaal of vragen heeft over de inhoud, neem dan contact op met uw accountmanager via e-mail of telefoon.'
  },
  IMPERSONATE: {
    TITLE: 'Customers - Impersonate mode',
    COMPANY_PLACEHOLDER: 'Zoek of selecteer een bedrijf',
    USER_PLACEHOLDER: 'Zoek of selecteer een gebruiker'
  },
  SET_COMPANY: {
    TITLE: 'Selecteer bedrijf',
    COMPANY_PLACEHOLDER: 'Zoek of selecteer een bedrijf'
  },
  VALIDATION_ERROR: {
    FIRSTNAME_REQUIRED: 'Voornaam is verplicht',
    LASTNAME_REQUIRED: 'Achternaam is verplicht',
    USERNAME_REQUIRED: 'Gebruikersnaam is verplicht',
    PASSWORD_REQUIRED: 'Wachtwoord is verplicht',
    ROLECREATE_NOTALLOWED: 'Rol niet geldig',
    PASSWORD_DIFFERENT: 'Wachtwoorden zijn niet gelijk',
    NEWPASSWORD_REQUIRED: 'Wachtwoord is verplicht',
    REPEATPASSWORD_REQUIRED: 'Wachtwoord is verplicht',
    NAME_REQUIRED: 'Naam is verplicht',
    EMAIL_REQUIRED: 'E-mail is verplicht',
    MINIMUM_ONE_TYPE: 'Er moet minimaal 1 type geselecteerd worden',
    PASSWORDTOOSHORT: 'Het wachtwoord is te kort.',
    PASSWORDREQUIRESNONALPHANUMERIC: 'Het wachtwoord moet minimaal 1 speciaal teken bevatten.',
    PASSWORDREQUIRESLOWER: 'Het wachtwoord moet ten minste 1 kleine letter bevatten.',
    USERNAMEALREADYTAKEN: 'Deze gebruikersnaam is al in gebruik.',
    EMAILALREADYTAKEN: 'Het e-mailadres is al in gebruik.',
    LOGIN_INCORRECT: 'Combinatie ongeldig',
    CUSTOMERNR_REQUIRED: 'Klantnummer is verplicht',
    COMPANYNAME_REQUIRED: 'Bedrijfsnaam is verplicht',
    CUSTOMERNRALREADYTAKEN: 'Klantnummer is al in gebruik',
    EMAIL_INVALID: 'Ongeldig e-mailadres',
    INVALIDTOKEN: 'Uw email activatie is verlopen. Klik op “wachtwoord vergeten” op de inlog pagina om een nieuw wachtwoord aan te maken.',
    TOKEN_REQUIRED: 'Token is verplicht',
    USER_MUST_HAVE_COMPANY: 'Uw account is niet meer gekoppeld. Indien niet correct, neem contact op met de Roba Metals accountmanager.'
  },
  ENUM: {
    PORTAL_STATUS: {
      ACTIVE: 'Actief',
      INACTIVE: 'Inactief'
    },
    USER_ROLE: {
      USER: 'Gebruiker',
      MANAGER: 'Manager',
      ADMINISTRATOR: 'Administrator',
      SUPERADMIN: 'Super Admin',
      SUPPORT: 'Support'
    },
    DOCUMENT_TYPE: {
      CERTIFICATES: 'Certificaten',
      INVOICES: 'Facturen',
      NOTSET: 'Niet ingesteld',
      PACKINGSLIPS: 'Pakbon',
      SALESAGREEMENTS: 'Verkoopovereenkomsten',
      SALESORDERS: 'Verkooporders'
    },
    DOCUMENT_SORT: {
      UPLOADDATEASC: 'Datum oplopend',
      UPLOADDATEDESC: 'Datum aflopend',
      DOCUMENTTYPEASC: 'Document type'
    },
    DOCUMENT_SEARCH_TYPE: {
      NONE: 'NONE',
      ARTICLENR: 'Uw artikelnummer',
      CLIENTREFERENCE: 'Uw referentienummer',
      SALESORDER: 'Verkoopordernummer',
      SALESAGREEMENT: 'Verkoopovereenkomstnummer',
      PACKINGSLIP: 'Pakbonnummer',
      BATCHNR: 'Batchnummer',
      CERTIFICATENR: 'Certificaatnummer',
      INVOICENR: 'Factuurnummer'
    }
  },
  DASHBOARD: {
    DOCUMENTS_ADDED: 'Toegevoegde documenten sinds het laatste bezoek.',
    LAST_VISIT: 'Laatste bezoek',
    TONNAGE_DELIVERED: 'Tonnen dit jaar geleverd aan',
    NEW_DOCUMENTS: 'Nieuwe documenten',
    DOCUMENTS: 'Documenten',
    SUPPORT_BLOCK: {
      ACTION: 'Voor vragen, neem contact met ons op',
      TITLE: 'Trusted partner in metal'
    }
  },
  DOCUMENTS: {
    DOCUMENT_TYPE: 'Document type',
    GROUP_FUTURE: 'Toekomst',
    GROUP_TODAY: 'Vandaag',
    GROUP_THIS_WEEK: 'Deze week',
    GROUP_THIS_MONTH: 'Deze maand',
    GROUP_LAST_MONTH: 'Vorige maand',
    GROUP_THIS_YEAR: 'Dit jaar',
    GROUP_PREVIOUS_YEARS: 'Voorgaande jaren',
    GROUP_SEARCH_RESULT: 'Zoekresultaten',
    GROUP_SEARCH_RELATED: 'Gerelateerde documenten voor {0} "{1}"',
    SEARCH_TEXT: 'Typ het {0} in om overeenkomende documenten te vinden',
    NO_DOCUMENTS_FOUND: 'Sorry, we hebben geen documenten gevonden',
    NO_VERSIONS_FOUND: 'Sorry, we hebben geen versies gevonden',
    BATCH_NUMBER: 'Batchnummer',
    CERTIFICATE_NUMBER: 'Certificaatnummer',
    EXTERNAL_CUSTOMER_REFERENCE: 'Klantreferentie',
    CUSTOMER_NUMBER: 'Klantnummer',
    INVOICE_NUMBER: 'Factuurnummer',
    PACKING_SLIP_NUMBER: 'Pakbonnummer',
    ROBA_NUMBER: 'Robanummer',
    DOWNLOAD_DOCUMENTS: 'Download documenten',
    PREPARING_YOUR_DOWNLOAD: 'Uw download voorbereiden',
    SELECTED_DOCUMENTS: 'Geselecteerde documenten',
    PREVIEW: 'Voorbeeld',
    SELECT_DOCUMENT: 'Selecteer document',
    RELATED_DOCUMENTS: 'Gerelateerde documenten',
    VERSION_HISTORY: 'Versie geschiedenis',
    DOWNLOAD: 'Download',
    UPLOAD_DATE: 'Upload datum',
    VERSION_NUMBER: 'Versie nummer',
    MULTIPLE_BATCHES: 'Meerdere batches',
    CERTIFICATE_MULTIPLE_BATCHES: 'Certificaten voor meerdere batches'
  },
  COMPANIES: {
    META_TITLE: 'Bedrijven',
    CREATE_COMPANY: 'Bedrijf aanmaken',
    SEARCH_PLACEHOLDER: 'Zoek naar een bedrijf bij naam of klantnummer',
    ROW_LABELS: {
      COMPANY_NAME: 'Bedrijfsnaam',
      CUSTOMER_NR: 'Klantnummer',
      DATE_CREATED: 'Aanmaakdatum',
      LAST_LOGIN: 'Laastse login',
      STATUS: 'Status'
    }
  },
  COMPANY: {
    ADD_COMPANY: {
      ACCESS_TO: 'Toegang tot welke bedrijven?',
      BUTTON: 'Een ander bedrijf toevoegen',
      NO_DATA: 'Geen bedrijven gevonden',
      PLACEHOLDER: 'Zoek een bedrijf op naam of Klant nummer.',
      TITLE: 'Bedrijven toevoegen'
    },
    COMBINE: 'De documentinformatie van de geselecteerde bedrijven combineren?',
    CORPORATE: 'Bedrijfsnaam',
    CORPORATE_DESCRIPTION: 'Deze naam wordt in de portal gebruikt.',
    EDIT_COMPANY: 'Wijzig bedrijf',
    DELETE_COMPANY: 'Verwijder bedrijf',
    DELETE_DESCRIPTION: 'Bij alle gekoppelde admins verdwijnt dit bedrijf.',
    SET_STATUS_ACTIVE: 'Zet status op "Actief"',
    SET_STATUS_INACTIVE: 'Zet status op "Inactief"',
    STATUS_ACTIVE_TITLE: 'Zet status op "Actief"?',
    STATUS_INACTIVE_TITLE: 'Zet status op "Inactief"?'
  }
}

export default translations
